import { MODEL_KEY } from 'modules/redux/constants/model-key'
import getSavableAssociationKeysReduxUtil from 'modules/redux/utils/get-savable-association-keys'
import getUpdatedDataReduxUtil from 'modules/redux/utils/get-updated-data'
import validateReduxUtil from 'modules/redux/utils/validate'
import {
  omitObjectUtil,
  pickObjectUtil
} from 'packages/src'

function getSavableDataReduxUtil (instance) {
  const savableAssociationKeys = getSavableAssociationKeysReduxUtil(instance)
  let {
    data,
    changed
  } = instance
  // If some keys are not valid, don't send them
  // e.g. Profile birthday is wrong and some other values are valid
  const validation = validateReduxUtil(instance)
  if (Array.isArray(validation)) {
    const invalidKeys = validation.map(valElement => valElement.key)
    changed = omitObjectUtil(changed, invalidKeys)
  } else if (validation) {
    changed = omitObjectUtil(changed, [validation.key])
  }
  // If it has not changed, only send the associations and foreign keys
  // which could have changed themselves.
  // Then the server will know not to update them if not necessary
  const hasNotChanged = !Object.keys(
    omitObjectUtil(changed, savableAssociationKeys)
  ).length
  if (hasNotChanged) {
    const foreignKeysToSave = Object.keys(data).filter(
      key => key.endsWith('Id')
    )
    const keysToSave = [
      MODEL_KEY.CLASS_NAME,
      MODEL_KEY.ID,
      ...savableAssociationKeys,
      ...foreignKeysToSave
    ]
    return {
      ...pickObjectUtil(data, keysToSave),
      ...changed
    }
  }
  // If the instance has changed, update it
  return getUpdatedDataReduxUtil(instance)
}

export default getSavableDataReduxUtil
